<h2 mat-dialog-title style="margin-bottom: 20px;">Operations Download</h2>
<mat-dialog-content class="container" style="margin-bottom: 10px; overflow: hidden;">
  <mat-form-field>
    <input matInput placeholder="Folder Path:" [pattern]="exportPattern" [formControl]="productionDownloadPath">
    <mat-error *ngIf="productionDownloadPath.errors?.pattern && (productionDownloadPath.dirty || productionDownloadPath.touched)">
      <p style="font-size: 10px;">Invalid path. Please follow standard format i.e. '\\Amazon\D\Processing_Files\Job_Opportunity_Folder'</p>
    </mat-error>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" [disabled]="productionDownloadPath.invalid" (click)="download()">Download</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
